import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { finalize, switchMap, take, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CoreState } from 'src/app/state/_state.interfaces';
import { selectSession } from 'src/app/state/_state.selectors';
import { LogoutSessions } from 'src/app/state/session.actions';

/**
 * 多重サブミット制御用のInterceptor
 * 同URLへの同時リクエスト数が1件になるようにする
 */
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  /** リクエスト状態を保持するためのSet */
  private requestStack: Array<string>;

  /**
   * コンストラクタ
   */
  constructor(
    private session: Store<CoreState>,
    private core: Store<CoreState>
  ) {
    this.requestStack = new Array<string>();
  }

  /**
   * ローダーの表示と多重サブミット制御
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const reqKey = this.createRequestKey(request);
    let reqUrls = this.requestStack.filter((strs) => {
        return strs == reqKey
        })
    if (reqUrls.length>2) {
      console.warn('現在リクエスト中のURLのため、新規リクエストは破棄しました[' + reqKey + ']');
      return from([]);
    }
    this.requestStack.push(reqKey);

    return this.core.select(selectSession).pipe(
      take(1),
      switchMap((session) => {
        let newRequest: HttpRequest<any> = null;
        if (session.auth && session.auth.token) {
          newRequest = request.clone({
            setHeaders: {
              Authorization: 'Bearer ' + session.auth.token
            }
          });
        } else  {
          newRequest = request.clone();
        }
        //console.log(newRequest);
        return next.handle(newRequest)
        .pipe(
          catchError((error: any) => {
            /* 401エラーを確認する */
              if (error.status == 401) {
                /* ログアウト処理を実行する */
                this.session.dispatch(new LogoutSessions());
                return throwError(error);
              }
              return throwError(error);
          })
        );
      }),
      finalize(() => {
        this.requestStack = this.requestStack.filter( e => {
          return e != reqKey;
        });
      })
    );
  }

  /**
   * リクエストを区別するキーの生成
   */
  private createRequestKey(request: HttpRequest<any>) {
    // const body = JSON.parse(request.body);
    // return request.url + '::' + body.id + '::' + body.procId;
    return request.url;
  }
}
